<template>
  <div id="app">
    <div v-if="user.isAuthenticated">
      <v-app>
        <v-main id="application">
            <div class="blue-lighten-5 radiation-main">
              <router-view/>
            </div> 
        </v-main> 
        <AppDrawer />
        <NavBar />
      </v-app>
    </div> 
    <div v-else>
      <!--<v-btn depressed @click="logIn()">Sign-In</v-btn>-->
      <h3>Access Denied</h3>
    </div>
  </div>
  <!--
  
  -->
  
</template>

<script>
  
  import {msalMixin} from 'vue-msal';
  import NavBar from '@/components/NavBar.vue'
  import AppDrawer from '@/components/AppDrawer.vue'
  
 
  export default {
    name:'app',
    data:function(){
      return{
        user:{
          name:'',
          userName:'',
          isAuthenticated:false,
          roles:[]
        },
        mixins: [msalMixin]
      }
    },
    components: {    
      NavBar,
      AppDrawer,
    },
    mounted:function(){
      this.logIn();
    },
    methods:{
      async logIn()
      {
        if(!this.$msal.isAuthenticated()){
          console.log('login...')
          await this.$msal.signIn();
        } 
        
        
                
        await this.$msal.acquireToken(["User.Read"])
           .then(response=>{
            if(response===false)
           {
            console.log("double try",this.$msal);
           }
           })
           .catch(error=>{
            console.log("error", error );
           });
          this.user.name=this.$msal.data.user.name;
          this.user.userName=this.$msal.data.user.userName,
          this.user.isAuthenticated=this.$msal.data.isAuthenticated;
          this.user.roles=this.$msal.data.user.idToken.roles
        
      },
      logOut()
      {
        if(this.$msal.isAuthenticated()){
          this.$msal.signOut();
        }
        this.user.isAuthenticated=false;
      }
    }
}
</script>


<style src="../node_modules/@grapecity/activereports/styles/ar-js-ui.css"></style>
<style src="../node_modules/@grapecity/activereports/styles/ar-js-designer.css"></style>


<style lang="scss">
.radiation-main {
  height: 100%;
  width: 100%;
  background-color: #729aac;
 // background-image: url('./assets/initialImage.png');
  padding: 1rem;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /*-webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;*/
  text-align: center;
  color: #2c3e50;
  
  
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>